import { IModal } from 'customTypes';
import { ModalBackground } from '../../assets/styles/Modal';
import TextEditor from '../TextEditor';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useEffect, useMemo, useRef, useState } from 'react';
import Carousel from 'react-multi-carousel';
import IssueGuide from '../IssueGuide';

const Root = styled.div`
  position: relative;
  transition: all ease 0.8s;
  width: 100%;
  height: 100vh;
  height: inherit;
  justify-content: center;
  align-items: center;
  display: flex;
  justify-content: center;
  align-items: center;
  .modal {
    z-index: 6000;
    display: flex;
    flex-direction: column;
    width: 46.2rem;
    height: 28rem;
    min-width: 24rem;
    background-color: var(--board);
    border-radius: 0.5rem;
    overflow: hidden;

    @media screen and (max-width: 1024px) {
      /* width: 80%; */
      width: calc(100vw - 2rem);
    }
    @media screen and (max-width: 767px) {
      width: 100%;
      height: 100vh;
      overflow-y: auto;
      border-radius: 0;
    }

    .widget-size-toggle {
      display: flex;
      gap: 0.5rem;
      padding: 0.4rem 1rem;
      > div {
        cursor: pointer;
        padding: 0.4rem 0.5rem 0.3rem 0.5rem;
        color: var(--text-secondary);
        border-bottom: 2px solid transparent;
        &:hover {
          color: var(--text-primary);
          border-bottom: 2px solid var(--primary);
        }
        &.active {
          color: var(--primary);
          font-weight: 500;
        }
      }
    }

    > .inputForm-head {
      user-select: none;
      position: relative;
      font-weight: 500;
      flex-shrink: 0;
      padding: 0.5rem;
      height: 3.5rem;
      border-bottom: 1px solid var(--outline);
      > svg {
        width: 24px;
        height: 24px;
      }
      .modalHeaderTitle {
        padding: 0 0.25rem;
        color: var(--text-primary);
      }
      .modalHeaderCenter {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: var(--text-primary);
      }
    }

    .widget-body {
      &.large {
        width: 740px;
        height: 340px;
      }
      &.small {
        width: 364px;
        height: 206px;
      }
      &.card {
        padding: 0 1rem 1rem;
        flex-grow: 1;

        .react-multi-carousel-list,
        .react-multi-carousel-track {
          height: 100%;
        }

        .notice-box {
          display: flex;
          flex-direction: column;
          gap: 0.5rem;
          width: 100%;
          height: 100%;
          border: 1px solid var(--outline);
          border-radius: 0.5rem;
          padding: 1rem;

          .notice-header {
            display: flex;
            flex-direction: column;
            gap: 0.1rem;

            .notice-info {
              color: #666;

              span {
                font-size: 0.75rem;
                line-height: 1.2;
              }
            }
            h4 {
              color: var(--text-primary);
              font-size: 1.125rem;
              line-height: 1.2;
              white-space: break-spaces;
            }
          }

          /* ckeditor custom style */
          .ck-editor-cont {
            height: 100%;
            overflow: hidden;
            border-top: 1px solid var(--outline);

            .ckeditor {
              height: 100%;

              /* 에디터 상단 툴바 제거 */
              .ck-editor__top {
                display: none;
              }

              .ck-rounded-corners .ck.ck-editor__main > .ck-editor__editable,
              .ck.ck-editor__main > .ck-editor__editable.ck-rounded-corners {
                height: 100%;
                border: none;
                padding: 0;
                overflow: hidden;
                white-space: normal;
              }
            }
            .ck-content span {
              white-space: normal !important;
              word-break: break-word !important;
              overflow-wrap: break-word !important;
              word-wrap: break-word !important;
            }
          }
        }

        .no-data {
          width: 100%;
          height: 100%;
          border: 1px solid var(--outline);
          border-radius: 0.5rem;
        }
      }
    }
  }
  .closeBtn {
    width: 2rem;
    height: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5rem;
    cursor: pointer;
    margin: 0 0.5rem;
    color: var(--text-primary);
  }
  .closeBtn:hover {
    background-color: var(--tonal);
  }
  .material-symbols-rounded {
    /* color: rgba(0, 0, 0, 0.8); */
    font-variation-settings: 'FILL' 1, 'wght' 500, 'GRAD' 0, 'opsz' 20;
  }
`;
const SliderWrapper = styled.div`
  padding: 1rem 2rem 2rem 2rem;
  height: inherit;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  .ck-editor__top {
    display: none;
  }
  .ck-content {
    border: 1px solid lightgray;
    border-radius: 0.25rem;
    padding: 1rem;
    height: 8rem;
    max-height: fit-content;
    /* height: 14vh; */
    /* max-height: 14vh; */
    overflow: hidden;
  }

  .slick-arrow {
    display: none !important;
  }

  .slick-dots {
    top: -2.6rem;
    width: inherit;
    right: 0;

    li {
      margin: 0;

      button:before {
        transition: all ease-in-out 0.2s;
        font-family: 'slick';
        font-size: 15px;
        line-height: 20px;
        position: absolute;
        top: 0;
        left: 0;
        width: 5px;
        height: 5px;
        border-radius: 5px;
        content: '';
        text-align: center;
        color: black;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        background-color: rgba(72, 216, 158, 1);
      }
    }

    .slick-active {
      button:before {
        width: 12px;
      }
    }
  }

  .titleBar {
    width: 0.5rem;
    height: 2rem;
    background-color: #2977ff;
    border-radius: 2px;
    margin-right: 0.5rem;
  }
  .flex-between {
    > div.flex-start {
      color: var(--text-secondary);
    }
    > div:nth-child(2) {
      color: var(--text-tertiary);
    }
  }
`;

const ANIMATION_DELAY = 3; // 애니메이션 딜레이 시간 / 3 = 3초;

const DashboardViewModal = ({ openModal, setOpenModal }: any) => {
  const { t } = useTranslation();
  const ckRef = useRef<HTMLDivElement | null>(null);
  const [curIdx, setCurIdx] = useState(0); // carousel 현재 인덱스 - carousel 슬라이드 변경시 애니메이션 초기화를 위해 사용

  // 닫기버튼 클릭
  const onClickClose = () => {
    setOpenModal((prev: IModal) => ({ ...prev, status: false }));
  };

  useEffect(() => {
    let handleAnimationEnd: (event: AnimationEvent) => void;
    let targetElement: HTMLDivElement;

    const checkElement = () => {
      targetElement = document.querySelector('.modal-contents .ckeditor') as HTMLDivElement;

      if (targetElement) {
        const viewHeight = Math.floor(document.querySelector('.modal-contents .ck-editor-cont')?.getBoundingClientRect().height || 0); // 뷰 높이
        const contentHeight = targetElement?.scrollHeight || 0; // 내용 전체 높이
        const fmtSecond = (contentHeight * 0.05).toFixed(2);
        const contentAnimation = contentHeight > viewHeight - 8 ? `slide ${fmtSecond}s ${ANIMATION_DELAY}s linear` : 'none';

        targetElement.style.animation = contentAnimation; // 애니메이션 적용

        // 애니메이션 종료 시 실행되는 이벤트 핸들러
        handleAnimationEnd = () => {
          targetElement.style.animation = 'none'; // 애니메이션 제거
          const reflow = targetElement.offsetHeight; // 리플로우 강제 발생 - 이렇게 안하면 재시작이 안됨
          targetElement.style.animation = contentAnimation; // 애니메이션 다시 적용
        };

        targetElement.addEventListener('animationend', handleAnimationEnd);
      } else {
        // 요소를 찾지 못했을 때 요소 탐색 재시도 - caurosel 라이브러리 사용시 로드될 때 요소를 못찾기 때문
        setTimeout(checkElement, 100);
      }
    };

    checkElement();

    return () => {
      if (targetElement && handleAnimationEnd) {
        targetElement.removeEventListener('animationend', handleAnimationEnd);
      }
    };
  }, [curIdx, openModal.size]);

  const responsive = useMemo(
    () => ({
      desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 1,
        // items: size === 'large' ? carouselCount : 1,
        slidesToSlide: 1, // optional, default to 1.
      },
      tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 1,
        // items: size === 'large' ? 2 : 1,
        slidesToSlide: 1, // optional, default to 1.
      },
      mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 1,
        slidesToSlide: 1, // optional, default to 1.
      },
    }),
    []
  );

  return (
    <ModalBackground onClick={onClickClose} role='presentation'>
      <Root>
        <div
          className='modal'
          role='presentation'
          onClick={(event) => {
            event.stopPropagation();
          }}
        >
          <div className='inputForm-head flex-between'>
            <div className='modalHeaderTitle'>{t('미리보기')}</div>
            <div className='closeBtn' onClick={onClickClose} role='presentation'>
              <span className='material-symbols-rounded'>close</span>
            </div>
          </div>
          <div className='inputForm-body'>
            <div className='modal-contents'>
              {openModal.data.widgetSize === 'small' && (
                <div className='flex-start widget-size-toggle'>
                  <div
                    className={openModal.size === 'small' || openModal.size === undefined ? 'active' : ''}
                    role='presentation'
                    onClick={() => setOpenModal((prev: IModal) => ({ ...prev, size: 'small' }))}
                  >
                    {t('소형 위젯 보기')}
                  </div>
                  <div className={openModal.size === 'large' ? 'active' : ''} role='presentation' onClick={() => setOpenModal((prev: IModal) => ({ ...prev, size: 'large' }))}>
                    {t('대형 위젯 보기')}
                  </div>
                </div>
              )}
              {openModal.data.widgetSize === 'small' && (
                <div className={`widget-body card ${openModal.size || 'small'}`}>
                  {openModal.data.cContent ? (
                    <Carousel
                      swipeable={false}
                      draggable={false}
                      responsive={responsive}
                      infinite={false}
                      autoPlay={false}
                      autoPlaySpeed={60000}
                      keyBoardControl
                      transitionDuration={500}
                      containerClass='carousel-container'
                      removeArrowOnDeviceType={['tablet', 'mobile', 'desktop']}
                      dotListClass='custom-dot-list-style'
                      showDots={false}
                      afterChange={(previousSlide, { currentSlide, onMove }: any) => {
                        setCurIdx(currentSlide);
                        // Carousel 슬라이드 변경시 애니메이션 초기화
                        const targetAll: NodeListOf<HTMLDivElement> | null = document.querySelectorAll('.urgent-wrap .react-multi-carousel-item');

                        if (targetAll) {
                          targetAll.forEach((nodeEl: HTMLDivElement) => {
                            const childNode = nodeEl.querySelector('.ckeditor') as HTMLDivElement | null;
                            if (childNode) {
                              childNode.style.animation = 'none';
                            }
                          });
                        }
                      }}
                    >
                      <div className='notice-box'>
                        <div className='notice-header'>
                          <h4>{openModal.data.cTitle}</h4>
                          <div className='notice-info'>
                            <span>{openModal.data.cDate}</span>
                          </div>
                        </div>

                        <div className='ck-editor-cont'>
                          <div
                            ref={(item: any) => {
                              ckRef.current = item;
                            }}
                          >
                            <TextEditor content={openModal.data.cContent} readOnly idx={openModal.data.cSeq} />
                          </div>
                        </div>
                      </div>
                    </Carousel>
                  ) : (
                    <div className='no-data'>
                      <IssueGuide text='현장 전달사항이 없습니다' />
                    </div>
                  )}
                </div>
              )}
              {openModal.data.widgetSize === 'large' && (
                <SliderWrapper>
                  <div className='widget-body card'>
                    <div className='notice-box'>
                      <div className='notice-header'>
                        <h4>{openModal.data.cTitle}</h4>
                        <div className='notice-info'>
                          <span>{openModal.data.cDate}</span>
                          <b> · </b>
                          <span>{openModal.data.writer}</span>
                        </div>
                      </div>
                      <div className='ck-editor-cont'>
                        <TextEditor content={openModal.data.cContent} readOnly />
                      </div>
                    </div>
                  </div>
                </SliderWrapper>
              )}
            </div>
          </div>
        </div>
      </Root>
    </ModalBackground>
  );
};

export default DashboardViewModal;
